import { WeatherInfo } from "../api/weatherInfo.type";
import {
  productLinks,
  Circumstance,
  Ctx,
  LinkResolver,
} from "./product-links";
import { AddLink, AdData } from "./AddLink";
import { getBeaufortWindForce } from "../weather/utils";
import { pickVariant } from "./rotation";

interface Props {
  weatherInfo: WeatherInfo | undefined | null;
  distance: number | undefined;
  placeName: string | undefined;
  headwindRatio: number | undefined;
}

const resolveLink = (link: LinkResolver, ctx: Ctx): string | null =>
  typeof link === "function" ? link(ctx) : link;

const resolveAd = (circumstance: Circumstance, ctx: Ctx): AdData | null => {
  const entry = productLinks[circumstance];
  const { variant, index } = pickVariant(circumstance, entry.variants);
  const link = resolveLink(variant.link, ctx);
  if (!link || link.startsWith("TODO")) return null;
  return {
    item: entry.item,
    provider: entry.provider,
    link,
    text: variant.text,
    variantIndex: index,
  };
};

export const Add = ({
  weatherInfo,
  distance,
  placeName,
  headwindRatio,
}: Props) => {
  if (!weatherInfo) {
    return null;
  }

  const ctx: Ctx = { placeName };
  const nowSec = Math.floor(Date.now() / 1000);
  const isDark = nowSec < weatherInfo.sys.sunrise || nowSec > weatherInfo.sys.sunset;
  const mainWeather = weatherInfo.weather?.[0]?.main;
  const isSunny = mainWeather === "Clear" && weatherInfo.main.temp > 20;
  const beaufort = getBeaufortWindForce(weatherInfo.wind.speed);

  const candidates: Array<Circumstance | null> = [
    weatherInfo.rain ? "rain" : null,
    weatherInfo.snow ? "snow" : null,
    distance !== undefined && distance > 50000 ? "overnight" : null,
    distance !== undefined && distance > 10000 && (headwindRatio ?? 0) > 0.4
      ? "headwindLong"
      : null,
    distance !== undefined && distance > 10000 ? "longDistance" : null,
    beaufort >= 4 ? "windy" : null,
    isDark ? "dark" : null,
    isSunny ? "sunny" : null,
    weatherInfo.main.temp < 10 ? "cold" : null,
    placeName?.includes("station") ? "cityLocation" : null,
    "fallback",
  ];

  for (const circumstance of candidates) {
    if (!circumstance) continue;
    const ad = resolveAd(circumstance, ctx);
    if (ad) return <AddLink link={ad} />;
  }

  return null;
};
